import { useMemo } from 'react';
import PropTypes from 'prop-types';

import useDetailTable from '#/hooks/table/useDetailTable';
import DetailTable from '#/modules/commonComponents/table/DetailTable';

/** 收款各區塊共用的唯讀明細表（同客訂分頁的 flat lines 樣式）。 */
const CollectionSimpleTable = ({ rows, columns, emptyText, rowIdPrefix }) => {
  const stableColumns = useMemo(() => columns, [columns]);
  const state = useDetailTable(rows, stableColumns, {
    enableExpanding: false,
    getRowId: (row, index) => String(row.id ?? `${rowIdPrefix}-${index}`),
  });

  if (rows.length === 0) {
    return <p className="px-4 py-5 text-sm text-muted-foreground">{emptyText}</p>;
  }

  return (
    <div className="detail-table-container">
      <DetailTable
        state={state}
        containerClassName="detail-table-scroll--section-embedded"
        tableClassName="detail-table--flat-lines"
      />
    </div>
  );
};

CollectionSimpleTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  emptyText: PropTypes.string.isRequired,
  rowIdPrefix: PropTypes.string.isRequired,
};

export default CollectionSimpleTable;
